import Vue from "vue";
import VueRouter from "vue-router";
import IndexView from "../components/IndexView.vue";
// import HomeView from "../views/HomeView.vue";
import ErrorView from "../views/ErrorView.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "index",
		component: IndexView,
		meta: { keepAlive: true },
	},
	{
		path: "/detail",
		name: "detail",
		component: () => import("../views/HomeDetailView.vue"),
	},
	{
		path: "/detail/:id",
		name: "detailWithId",
		component: () => import("../views/HomeDetailView.vue"),
	},
	{
		path: "/search",
		name: "search",
		component: () => import("../views/SearchView.vue"),
		meta: { keepAlive: true },
	},
	{
		path: "/recharge",
		name: "recharge",
		component: () => import("../views/RechargeView.vue"),
	},
	{
		path: "/shopCart",
		name: "shopCart",
		component: () => import("../views/ShopCartView.vue"),
	},
	{
		path: "/order",
		name: "order",
		component: () => import("../views/OrderView.vue"),
	},
	{
		path: "/order-list",
		name: "order-list",
		component: () => import("../views/OrderListView.vue"),
	},
	{
		path: "/order-detail",
		name: "order-detail",
		component: () => import("../views/OrderDetailView.vue"),
	},
	{
		path: "/order-delivery",
		name: "order-delivery",
		component: () => import("../views/OrderDeliveryDetailView.vue"),
	},
	{
		path: "/payment-result/:order_no",
		name: "payment-result",
		component: () => import("../views/PaymentResultView.vue"),
	},
	{
		path: "/my",
		name: "my",
		component: () => import("../views/MyView.vue"),
	},
	{
		path: "/address",
		name: "address",
		component: () => import("../views/AddressView.vue"),
	},
	{
		path: "/address/add",
		name: "address-add",
		component: () => import("../views/AddressAddView.vue"),
	},
	{
		path: "/product/:id",
		name: "productDetail",
		component: () => import("../views/ProductDetailView.vue"),
	},
	{
		path: "/register",
		name: "register",
		component: () => import("../views/RegisterView.vue"),
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/LoginView.vue"),
	},
	{
		path: "/package-detail",
		name: "package-detail",
		component: () => import("../views/PackageDetailView.vue"),
	},
	{
		path: "/package-purchase",
		name: "package-purchase",
		component: () => import("../views/PackagePurchaseView.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: ErrorView,
	},
	{
		path: "*", // 通配符路由放在最后
		redirect: "/404",
	},
];

const router = new VueRouter({
	routes,
});

export default router;
